module.exports = __webpack_public_path__ + "media/room.5d7c0bab.mp4";